import React, { useState, useEffect } from "react";
import { getOfficeByOfficeHierarchyId } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";
import { useMutation } from "react-query";
import OfficeSettingsTable from "../../OfficeSettings/OfficeSettingsTable";
const OfficeHierarchyOfficesTable = ({ data }) => {
  const [officeSettings, setOfficeSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const getOfficeSettings = useMutation(
    (officeHierarchyId) => getOfficeByOfficeHierarchyId(officeHierarchyId),
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setOfficeSettings(res);
        setLoading(false);
      },
    }
  );

  useEffect(() => {
    getOfficeSettings?.mutate(data?.officeHierarchyId);
  }, []);

  return (
    <div className="w-full p-2 bg-white">
      <div className="">
        <div className="text-base ">
          {officeSettings && officeSettings ? <OfficeSettingsTable
            data={officeSettings}
            isLoading={loading}
            viewFromOH={true}
          /> : <></>}

        </div>
      </div>
    </div>
  );
};

export default OfficeHierarchyOfficesTable;
